export default "__VITE_ASSET__BcGoUYmx__"